import { useState } from 'react';
import { FOLLOW_UP_UI_TEXT } from '../constants/follow-up-intents';

// Constants for form logic
const DEFAULT_FIELD_NAME = 'Value';
const EMPTY_VALUES_LENGTH = 0;
const SINGLE_VALUE_LENGTH = 1;
const SLICE_START_INDEX = 0;
const SLICE_END_INDEX = -1;

export const useInformationForm = () => {
  const [showProvideForm, setShowProvideForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [formFields, setFormFields] = useState([]);
  const [currentFormMessageId, setCurrentFormMessageId] = useState(null);

  const setupForm = (messageId, messageText) => {
    // Extract field names from message (e.g., "Please provide: Start_Date, End_Date" -> ["Start_Date", "End_Date"])
    const fieldsText = messageText?.replace(FOLLOW_UP_UI_TEXT.PLEASE_PROVIDE_PREFIX, '') || DEFAULT_FIELD_NAME;
    const fieldNames = fieldsText.split(',').map(name => name.trim());
    
    // Set up form with separate fields
    const fields = fieldNames.map(fieldName => ({
      name: fieldName,
      label: fieldName,
      required: true
    }));
    
    const initialData = {};
    fieldNames.forEach(name => {
      initialData[name] = '';
    });
    
    setFormFields(fields);
    setFormData(initialData);
    setCurrentFormMessageId(messageId);
    setShowProvideForm(true);
  };

  const handleFormInputChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const createFormMessage = () => {
    // Convert form data to natural language format
    const values = Object.values(formData)
      .filter(value => value && value.trim() !== ''); // Only include non-empty values
    
    if (values.length === EMPTY_VALUES_LENGTH) return null;
    
    // Create natural language message
    return values.length === SINGLE_VALUE_LENGTH 
      ? values[0] 
      : `${values.slice(SLICE_START_INDEX, SLICE_END_INDEX).join(', ')} and ${values[values.length - 1]}`;
  };

  const closeForm = () => {
    setShowProvideForm(false);
    setFormData({});
    setFormFields([]);
    setCurrentFormMessageId(null);
  };

  return {
    showProvideForm,
    formData,
    formFields,
    currentFormMessageId,
    setupForm,
    handleFormInputChange,
    createFormMessage,
    closeForm
  };
};
